let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hJZ31")).then(() => parcelRequire('4jCd5'));